import { render } from "./DatePicker.vue?vue&type=template&id=05f173b4&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"

import "./DatePicker.vue?vue&type=style&index=0&id=05f173b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f173b4"]])

export default __exports__